import React from 'react';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(0, 3),
  },
  paper: {
    maxWidth: 400,
    margin: `${theme.spacing(1)}px`,
    padding: theme.spacing(2),
  },
}));

const ProviderResources = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Grid container wrap="nowrap" spacing={2}>
        <Grid item>
          <a href="/resources/ClickabilityBrandAssets.zip"target="_blank">
            <CloudDownload/>
          </a>
        </Grid>
        <Grid item xs>
          <Typography variant="h2">Clickability Logo Pack</Typography>
          <Typography>Get your website ready with these Clickability logos.</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProviderResources;
